/* eslint-disable @typescript-eslint/naming-convention */
export const localStorageKeys = {
  LANGUAGE: 'lang',
  CURRENCY: 'currency',
  TOKEN: 'avpt',
  DEVICE_SERIAL_NUMBER: 'dsn',
  PHONE_NUMBER: 'pno',
  REGISTRATION_TOKEN: 'ragxt',
  USER_INFO: 'upayogakarta',
  DEVICE_ID: 'did',
  REDIRECT_URL: 'redirectUrl',
  GA_CLIENT_ID: 'ga:clientId',
  SELECTED_AIRPORT_CODE: 'selectedAirportCode',
  GUEST_ID: 'guestId',
  GUEST_DEVICE_ID: 'guestDeviceId',
  USER_ID: 'userId',
  PID: 'pid',
  KEY: 'Key',
  FLIGHT_ID: 'flight_id',
  FLIGHT_DATE: 'flight_date',
  PICKUP_TIME: 'pickup_time',
  TEMP_STORE_ID: 'tempStoreId',
  FOOD_CART: 'foodCart',
  CLIENT: 'client',
  PARTNER: 'partner',
  FLIGHT_SEARCH_QUERY: 'flightSearchQuery',
  HOTEL_SEARCH_QUERY: 'hotelSearchQuery',
  HOTEL_DEAL_SEARCH_QUERY: 'hotelDealSearchQuery',
  ENT_HOTEL_DEAL_SELECTED_CITY: 'entHotelDealSelectedCity',
  HOTEL_PRICE_INFO: 'hotelPriceInfo',
  HOTEL_GUEST_INFO: 'hotelGuestInfo',
  FINAL_PRICE: 'finalPrice',
  DISCOUNT: 'discount',
  PLATFORM_ID: 'plid',
  IS_MEMBER: 'ismem',
  MOBILE_REGISTRATION_TOKEN: 'mragxt',
  IS_DD_DISABLED: 'isdddisabled',
  TRACKED_FLIGHTS: 'tracflights',
  ADDRESS: 'address',
  LAT_LONG_DATA: 'latlong',
  TOUR_EXP_CHECKOUT: 'tourExpCheckout',
  TOUR_EXP_SEARCH_QUERY: 'tourExperienceSearchQuery',
  ATTRACTION_SEARCH_QUERY: 'attractionSearchQuery',
  ATTRACTION_RECENT_SEARCHES: 'attractionRecentSearches',
  PASSENGER_LIST: 'passengerList',
  USER_TYPE: 'userType',
  IS_PRIME_TOGGLE_ENABLED: 'isPrimeToggleEnabled',
  ALLOW_REGISTRATION: 'allowRegistration',
  BUS_SEARCH_QUERY: 'busSearchQuery',
  LOUNGE_SEARCH_QUERY: 'loungesearchquery',
  FASTTRACK_SEARCH_QUERY: 'fasttracksearchquery',
  BUS_BOOKING_REVIEW: 'busBookingReview',
  BUS_PASSENGER_LIST: 'busPassengerList',
  RECENT_SEARCHES: 'recentSearches',
  BUS_CONTACT_DETAILS: 'busContactDetails',
  GUEST_TOKEN: 'guestTk',
  SOFT_LOGIN_SHOWN: 'softLoginShown',
  IS_UPDATE_MODAL: 'isUpdateModal',
  DEFAULT_SSO_URL: 'defaultSSOUrl',
  REFERAL_PARAMETER: 'referalparameter',
  TOUR_AND_EXP_BOOKING_REVIEW: 'tourAndExpBookingReview',
  JOURNEY_TYPE: 'journeyType',
  VOUCHER_CODE: 'voucherCode',
  JSP_FLOW: 'jspFlow',
  DUTYFREE: 'dutyfree',
  /** @deprecated Migrated into {@link localStorageKeys.DUTYFREE} */
  DUTYFREE_TRAVEL_COUNTRY: 'dutyfreeTravelCountry',
  /** @deprecated Migrated into {@link localStorageKeys.DUTYFREE} */
  DUTYFREE_RECENT_AIRPORTS: 'dutyfreeRecentAirports',
};
